import { DeviceType } from '@/__generated__/graphql';

export type DeviceTypeAttributes = {
  value: DeviceType;
  label: string;
};

const deviceTypeLabels: Record<DeviceType, string> = {
  [DeviceType.Cfc]: 'CFC',
  [DeviceType.IF]: 'I-F',
  [DeviceType.IL]: 'I-L',
  [DeviceType.Regis]: 'Regis',
  [DeviceType.T]: 'T',
  [DeviceType.T_5]: 'T5',
  [DeviceType.T_5L]: 'T5-L',
  [DeviceType.T_5Lg]: 'T5-LG',
  [DeviceType.T_5Lv]: 'T5-LV',
  [DeviceType.TCore]: 'Tcore',
  [DeviceType.TCoreF]: 'Tcore-F',
  [DeviceType.TCoreL]: 'Tcore-L',
  [DeviceType.TCoreLf]: 'Tcore-LF',
  [DeviceType.TCoreLg]: 'Tcore-LG',
  [DeviceType.TCoreLv]: 'Tcore-LV',
  [DeviceType.TCoreNv]: 'Tcore-NV',
  [DeviceType.TCoreWq]: 'Tcore-WQ',
  [DeviceType.TF]: 'T-F',
  [DeviceType.TG]: 'T-G',
  [DeviceType.TL]: 'T-L',
  [DeviceType.TLv]: 'T-LV',
  [DeviceType.TMicro]: 'Tmicro',
  [DeviceType.TMicroL]: 'Tmicro-L',
  [DeviceType.TMicroLg]: 'Tmicro-LG',
  [DeviceType.TMicroLv]: 'Tmicro-LV',
  [DeviceType.TNano]: 'Tnano',
  [DeviceType.TNanoL]: 'Tnano-L',
};

export const getDeviceTypeAttributes = (key: DeviceType): DeviceTypeAttributes => {
  if (!(key in deviceTypeLabels)) {
    throw new Error(`Key ${key} not found in the DeviceType attributes map`);
  }
  return {
    value: key,
    label: deviceTypeLabels[key],
  };
};

export const getAllDeviceTypeAttributes = (): DeviceTypeAttributes[] => {
  return Object.values(DeviceType).map((key) => getDeviceTypeAttributes(key));
};

export const isDeviceType = (key: string): key is DeviceType => {
  const deviceTypes = Object.values(DeviceType);
  return deviceTypes.includes(key as DeviceType);
};
